import { render } from "./PlantStatisticsView.vue?vue&type=template&id=1e8213c6&ts=true"
import script from "./PlantStatisticsView.vue?vue&type=script&lang=ts"
export * from "./PlantStatisticsView.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__